import React from 'react';

export default () => <div>Could not find template</div>;
